/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const EmailIcon = ({
  className,
  style: styleFromProps,
  color = '#938BB7',
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      style={style}
      className={classNames(className)}
      onClick={onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 2.25H1.50001C0.672715 2.25 0 2.92271 0 3.75001V14.25C0 15.0773 0.672715 15.75 1.50001 15.75H16.5C17.3273 15.75 18 15.0773 18 14.25V3.75001C18 2.92271 17.3273 2.25 16.5 2.25ZM1.50001 2.99999H16.5C16.5553 2.99999 16.604 3.02013 16.6558 3.03152C15.3572 4.22005 11.0511 8.15938 9.54422 9.51708C9.4263 9.62329 9.23625 9.74999 9.00004 9.74999C8.76382 9.74999 8.57377 9.62329 8.45547 9.51673C6.9487 8.15924 2.64238 4.2197 1.34395 3.03159C1.39591 3.0202 1.44471 2.99999 1.50001 2.99999ZM0.749988 14.25V3.75001C0.749988 3.67654 0.772137 3.60988 0.791965 3.54273C1.7859 4.45243 4.7905 7.20109 6.73871 8.97272C4.79682 10.6408 1.79146 13.4901 0.789609 14.4455C0.771926 14.3817 0.749988 14.3193 0.749988 14.25ZM16.5 15H1.50001C1.44011 15 1.38684 14.9791 1.33091 14.9658C2.36616 13.9789 5.39065 11.1131 7.2984 9.48108C7.5471 9.70668 7.77428 9.91237 7.95336 10.0737C8.26246 10.3528 8.62425 10.5 9 10.5C9.37575 10.5 9.73754 10.3528 10.0463 10.0741C10.2254 9.91266 10.4528 9.70678 10.7016 9.48108C12.6095 11.113 15.6335 13.9785 16.6691 14.9658C16.6132 14.9791 16.56 15 16.5 15ZM17.25 14.25C17.25 14.3193 17.2281 14.3817 17.2104 14.4455C16.2082 13.4896 13.2032 10.6406 11.2613 8.97275C13.2096 7.20113 16.2137 4.45271 17.208 3.54266C17.2279 3.60981 17.25 3.6765 17.25 3.74998V14.25Z"
        fill={color}
      />
    </svg>
  );
};
